import { render, staticRenderFns } from "./EntryProfile.vue?vue&type=template&id=5c4cf80a&scoped=true"
import script from "./EntryProfile.vue?vue&type=script&lang=ts"
export * from "./EntryProfile.vue?vue&type=script&lang=ts"
import style0 from "./EntryProfile.vue?vue&type=style&index=0&id=5c4cf80a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4cf80a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4cf80a')) {
      api.createRecord('5c4cf80a', component.options)
    } else {
      api.reload('5c4cf80a', component.options)
    }
    module.hot.accept("./EntryProfile.vue?vue&type=template&id=5c4cf80a&scoped=true", function () {
      api.rerender('5c4cf80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EntryProfile.vue"
export default component.exports